<template>
    <div class="main-background">
         <div class="filter-page-back-button" @click="returnToLastPage">
            <chevron-left-icon class="back-button-icon"/>
            <p class="back-button-text">Детальна інформація</p>
          </div>
          <div class="main-image-container">
            <img :src=" openedProduct.img" alt="" class="main-image">
            <div>
                <p class="product-info-name">{{ openedProduct.name }}</p>
                <div class="price-counter-line-container">
                    <div class="product-price-container">
                        <p class="product-price-name">Ціна:</p>
                        <p class="product-price">{{ `${openedProduct.price} грн.` }}</p>
                        <div class="closed-price">
                            <p class="product-sale">
                                {{ `${openedProduct.price_old} грн.` }}
                            </p>
                              <div class="closed-price-line"></div>
                        </div>
                    
                    </div>
                    <div class="product-counter-container">
                        <button :disabled="isAddedTocart || productCounter === 1" class="product-counter-button" @click="setChangeCounter('-')">
                            <minus-icon
                            class="product-counter-button-icon"/>
                        </button>
                        <input type="text" class="product-counter-input" @keyup.enter="handleEnterKey" v-model="productCounter" @input="validateInput" :max="openedProduct.qty">
                        <button :disabled="isAddedTocart || openedProduct.qty === Number(productCounter)" class="product-counter-button" @click="setChangeCounter('+')">
                            <plus-icon
                            class="product-counter-button-icon"/>
                        </button>
                    </div>
                </div>
            </div>
            <div class="small-descr-container">
                 <p class="product-code">{{ `Код ${openedProduct.id}` }}</p>
                  <p class="product-code">{{ `Залишилось на складі: ${openedProduct.qty} шт.` }}</p>
            </div>
           
          </div>
          <div class="product-info-container">
            <p class="product-info-title">Опис</p>
            <p class="product-info">{{ openedProduct.description }}</p>
          </div>
          <div class="bottom-filter-button-container">
                <button 
                class="filtration-button" 
                @click="setAddproductToCart"
                >
                <card-button-icon
                v-if="!isAddedTocart"
                class="add-cart-bbutton"
                />
                {{ isAddedTocart ? 'В корзині' : 'Додати в кошик'  }}
                <check-icon
                v-if="isAddedTocart"
                class="add-cart-bbutton"
                />
            </button>
          </div>
    </div>
</template>

<script>

import { ChevronLeftIcon, CheckIcon, PlusIcon, MinusIcon } from 'vue-feather-icons'
import CardButtonIcon from "../icons/CardButtonIcon.vue"

export default {
    name: "product-page",
    components: {
        ChevronLeftIcon,
        CardButtonIcon,
        CheckIcon,
        PlusIcon,
        MinusIcon
    },
    props: {
        perPage: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            mainOpenProduct: {
                id: null,
                img: null,
                name: null,
                price: null
            },
            productCounter: 1,
            isAddedTocart: false
        }
    },
    mounted() {
        window.scrollTo(0, 0);
        if (this.getCustomerCart.items.find(el => el.product_id === this.openedProduct.id)) {
            this.isAddedTocart = true
        }
        document.body.addEventListener('click', (event) => {
        let target = event.target
        target
      })
    },
    computed: {
       openedProduct() {
         return this.$store.getters.openedProduct
       },
       perPageName() {
         return this.$store.getters.perPageName
       },
       getOrderId() {
        return this.$store.getters.getOrderId
       },
       getCustomerCart() {
        return this.$store.getters.getCustomerCart
       }
    },
    methods: {
        handleEnterKey() {
            const activeElement = document.activeElement
            if (activeElement.tagName === 'INPUT') {
            activeElement.blur()
            }
       },
        validateInput() {
            this.productCounter = this.productCounter.replace(/\D/g, '');

             const numericValue = parseInt(this.productCounter);
            if (numericValue > this.openedProduct.qty) {
                this.productCounter = this.openedProduct.qty.toString();
            } 
        },
        setChangeCounter(value) {
            if (value === '+') {
                this.productCounter = Number(this.productCounter) + 1
            } else {
                this.productCounter = Number(this.productCounter) - 1
            }
        },
        setAddproductToCart() {
            if (this.isAddedTocart) {
                 this.$emit('setIsChangePage', 'cart')
            }
            let data = {
                order_id: this.getOrderId.id,
                product_id: this.openedProduct.id,
                quantity: Number(this.productCounter) ? Number(this.productCounter) : 1
            }
            try {
              this.$store.dispatch('addProductToCart', JSON.stringify(data))
              this.isAddedTocart = !this.isAddedTocart
               this.$emit('setIsChangePage', 'cart')
            } catch (error) {
                console.log(error.message)
            } 
        },
        returnToLastPage() {
            if (this.perPageName === 'home') {
                this.$emit('setIsChangePage', 'home', '')
            } else {
                this.$emit('setIsChangePage', 'product', 'productInfo')
            }
        }
    },
    watch: {

    }
}
</script>

<style scoped>

.small-descr-container {
    display: flex;
    justify-content: space-between;
}

.main-background {
    background: #fff;
}
.filter-page-back-button {
    position: relative;
    border-bottom: 1px solid #F0F0F0;
    padding: 18px;
    cursor: pointer;
}

.back-button-icon {
    position: absolute;
}

.back-button-text {
    text-align: center;
}

.main-image-container {
   width: 100%;
   padding: 0 16px; 
   border-bottom: 1px solid #F0F0F0;
}

.main-image {
    width: 100%;
    /* height: 375px;  */
}

.bottom-filter-button-container {
  position: fixed;
  bottom: -2px;
  width: 100%;
  left: 0px;
  background: #FFF;
  box-shadow: 0px -4px 4px 0px rgba(0, 0, 0, 0.04);
  padding: 16px;
}

.filtration-button {
    padding: 12px;
    width: 100%;
    border-radius: 8px;
    background: #16ABB8;  
    color: #FFF;
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    border: none;
    cursor: pointer;
}

.product-info-name {
    color: #333;
    font-family: Inter;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    max-width: 250px;
}

.product-price-container {
    display: flex;
    gap: 6px;
}

.product-price-name {
    color: #333;
font-family: Inter;
font-size: 18px;
font-weight: 600;
line-height: 24px;
}

.product-price {
 color: #E3000F;
font-family: Inter;
font-size: 18px;
font-weight: 500;
line-height: 24px;
}

.product-sale {
  color: rgba(227, 0, 15, 0.60);
font-family: Inter;
font-size: 14px;
font-weight: 500;
line-height: 24px;  
}

.closed-price {
    position: relative;
}

.closed-price-line {
    position: absolute;
    width: 95%;
    height: 1px;
    background: rgba(227, 0, 15, 0.60);
    font-family: Inter;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    transform: rotate(-15deg);
    top: 13px; 
}

.price-counter-line-container {
    display: flex;
    margin: 8px 0;
}

.product-counter-container {
    display: flex;
    gap: 4px;
    margin-left: auto;
}
.product-counter-button {
    border: 1px solid #C4C4C4;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    cursor: pointer;
}
.product-counter-button-icon {
    width: 8px;
    height: 8px;
}
.product-counter-input {
    width: 40px;
    height: 24px;
    border-radius: 4px;
    background: #F0F0F0;
    border: none;
    text-align: center;
    outline-offset: 0;
    outline: 0;
    color: #707070;
    text-align: center;
    font-family: 'Lato', sans-serif;
    font-size: 14px;
    font-weight: 400;
    line-height: 16px;
}
.product-code {
    color: #707070;
    font-family: Inter;
    font-size: 10px;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 6px;
}
.product-info-container {
    padding: 0 16px 100px 16px;
}
.product-info-title {
    margin-top: 11px;
    color: #333;
    font-family: Inter;
    font-size: 16px;
    font-weight: 600;
    line-height: 20px;
}
.product-info {
    color: #707070;
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    margin-top: 3px;
}
.add-cart-bbutton {
    vertical-align: bottom;
}

</style>